var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lv-input-group lv-input-group-preformat"},[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.label))]),_c('pre',{staticClass:"value",domProps:{"innerHTML":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }